/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MyDocumentResponseDto } from '../../models/my-document-response-dto';

export interface MyDocumentsControllerGetMyDocuments$Params {
}

export function myDocumentsControllerGetMyDocuments(http: HttpClient, rootUrl: string, params?: MyDocumentsControllerGetMyDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MyDocumentResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, myDocumentsControllerGetMyDocuments.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MyDocumentResponseDto>>;
    })
  );
}

myDocumentsControllerGetMyDocuments.PATH = '/user-documents/my';
